import { Skeleton } from '@bbl-digital/snorre-v2'
import React from 'react'

const MenuLoading: React.FC = () => (
  <div className="grid grid-cols-1 auto-rows-[50px] items-center pl-4 text-[13px] opacity-20">
    {[1, 2, 3, 4].map((i) => (
      <div key={i} className="grid grid-cols-[16px_1fr] gap-x-[10px]">
        <Skeleton width="16px" height="16px" />
        <Skeleton height="16px" />
      </div>
    ))}
  </div>
)

export default MenuLoading
